/**
 * Payment Service
 *
 * All payment and PDF-related API calls.
 * Maps to FastAPI endpoints in routes/payment.py
 */

import api from './api'

export const paymentService = {
  /**
   * Check purchase eligibility
   * POST /api/payment/check-eligibility
   *
   * Determines whether the property is likely to benefit from a support pack.
   *
   * @returns {Promise} - Response with ok_to_purchase, reason, num_comps
   */
  async checkEligibility() {
    return api.post('/api/payment/check-eligibility')
  },

  /**
   * Create Stripe Checkout Session
   * POST /api/payment/create-checkout-session
   *
   * Initiates Stripe payment flow for the $149 appeal pack.
   *
   * @returns {Promise} - Response with checkout_url to redirect to
   */
  async createCheckoutSession() {
    return api.post('/api/payment/create-checkout-session')
  },

  /**
   * Get Appeal Data - Property and comp data for PDF
   * GET /api/my-appeal
   *
   * Returns the property segments and appeal information.
   * Only available after purchase.
   *
   * @returns {Promise} - Response with appeal_data array
   */
  async getAppealData() {
    return api.get('/api/my-appeal')
  },

  /**
   * Download PDF - Generate and download appeal pack PDF
   * GET /api/payment/download-pdf
   *
   * Returns PDF file as blob.
   * Only available after purchase.
   *
   * @returns {Promise} - Response with PDF blob
   */
  async downloadPDF() {
    // Use responseType: 'blob' to handle binary PDF data
    return api.get('/api/payment/download-pdf', {
      responseType: 'blob'
    })
  },

  /**
   * Get Report Maps - Parcel and satellite map data URIs
   * GET /api/report/maps
   *
   * Returns base64 data URIs for the customer's personalized maps.
   * Only available after purchase.
   *
   * @returns {Promise} - Response with { parcel, satellite } data URIs
   */
  async getMaps() {
    return api.get('/api/report/maps')
  }
}

export default paymentService
